import { useEffect, useRef, useState } from 'react';
import "../style/video-player.css";

export default function VideoPlayer({ video, extension, autoplay }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);

    useEffect(() => {
        const handlePause = () => setIsPlaying(false);
        const handlePlay = () => setIsPlaying(true);

        const videoElement = videoRef.current;
        videoElement.addEventListener('pause', handlePause);
        videoElement.addEventListener('play', handlePlay);

        // Cleanup event listeners on unmount
        return () => {
            videoElement.removeEventListener('pause', handlePause);
            videoElement.removeEventListener('play', handlePlay);
        };
    }, []);

    useEffect(() => {
        // Ensure play button reappears when switching videos
        setIsPlaying(false);

        // Autoplay video on source change if autoplay is true
        if (autoplay && videoRef.current) {
            const videoElement = videoRef.current;
            const playPromise = videoElement.play();

            if (playPromise !== undefined) {
                playPromise.catch((error) => {
                    if (error.name === 'NotAllowedError' || error.name === 'AbortError') {
                        // Handle the error based on the error name
                        console.warn('Play request was interrupted:', error);
                    } else {
                        console.error('Play request failed:', error);
                    }
                });
            }
        }
    }, [video, autoplay]);

    const handleClick = () => {
        if (videoRef.current.paused) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    }

    return (
        <div className="video-player">
            {isPlaying ? "" : <div className="play-button" onClick={handleClick} />}
            <video ref={videoRef} src={`../assets/videos/${video.fileName}`} onClick={handleClick} autoPlay={autoplay}>
                <source type={`video/${extension}`} />
            </video>
        </div>
    );
}
